import { render, staticRenderFns } from "./form-controls.vue?vue&type=template&id=30c207e0"
import script from "./form-controls.vue?vue&type=script&lang=js"
export * from "./form-controls.vue?vue&type=script&lang=js"
import style0 from "./form-controls.vue?vue&type=style&index=0&id=30c207e0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports